import { ScheduleContentTabs, ScheduleContentTab } from '@/components/public/EventScheduleTabs';

import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Printer } from 'lucide-react';

interface EventScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  eventName: string;
  tabs: ScheduleContentTab[];
}

const EventScheduleModal: React.FC<EventScheduleModalProps> = ({
  isOpen,
  onClose,
  eventName,
  tabs
}) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Event Schedule - {eventName}</span>
            <Button
              variant="outline"
              size="sm"
              onClick={handlePrint}
              className="ml-2"
            >
              <Printer className="h-4 w-4 mr-1" />
              Print
            </Button>
          </DialogTitle>
        </DialogHeader>
        
        <div className="mt-4">
          <ScheduleContentTabs tabs={tabs} />
        </div>

        <div className="flex justify-end mt-6">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EventScheduleModal;
